/* eslint-disable no-cond-assign */
/* eslint-disable no-restricted-syntax */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import cssVars from 'css-vars-ponyfill';
import _ from 'lodash';
import { isDev } from './system';
/** 节流函数 */
export var throttle = function (func, wait) {
    var ctx;
    var args;
    var rtn;
    var timeoutID;
    var last = 0;
    function call() {
        timeoutID = 0;
        last = +new Date();
        rtn = func.apply(ctx, args);
        ctx = null;
        args = null;
    }
    return function throttled() {
        var args2 = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args2[_i] = arguments[_i];
        }
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        ctx = this;
        args = args2;
        var delta = Number(new Date()) - last;
        if (!timeoutID)
            if (delta - last >= wait)
                call();
            else
                timeoutID = setTimeout(call, wait - delta);
        return rtn;
    };
};
/** 获取指定路径参数 */
export var getParams = function (str, name) {
    // window.location.search.substr(1)
    var reg = new RegExp("(^|&)".concat(name, "=([^&]*)(&|$)"), 'i');
    var r = str.match(reg);
    if (r != null)
        return decodeURIComponent(r[2]);
    return null;
};
/** 获取字节常熟 */
export var getByteLen = function (val) {
    var withoutSpace = val.replace(/^\s+|\s+$/g, '');
    var len = 0;
    for (var i = 0; i < withoutSpace.length; i++) {
        var a = withoutSpace.charAt(i);
        // eslint-disable-next-line no-control-regex
        if (a.match(/[^\x00-\xff]/gi) != null) {
            len += 2;
        }
        else {
            len += 1;
        }
    }
    return len;
};
/** 获取游戏Key */
export var getGameKey = function (paths) {
    if (paths === void 0) { paths = []; }
    return paths[paths.length - 1];
};
/** 获取项目key */
export var getPlatformKey = function (paths) {
    if (paths === void 0) { paths = []; }
    return paths[paths.length - 2];
};
/** 获取聊天信息 */
export var getInfo = function () {
    var _a;
    var searchParams = (_a = window.location) === null || _a === void 0 ? void 0 : _a.search.substring(1);
    var platform = getPlatformKey(window.location.pathname.split('/'));
    var game_key = getGameKey(window.location.pathname.split('/'));
    var _b = window.IM, uid = _b.uid, u = _b.u, token = _b.token;
    var is_client = window.IM.isClient;
    var runtime = window.IM.runtime;
    var t = getParams(searchParams, 't') || getParams(searchParams, 'time');
    var i = getParams(searchParams, 'i');
    var v = getParams(searchParams, 'v');
    var flag = getParams(searchParams, 'flag');
    var safe_area_inset_bottom = getParams(searchParams, 'safeAreaInsetBottom') || '0';
    var _c = window.IMBridge, is_support_file = _c.is_support_file, show_back_im_btn = _c.show_back_im_btn, show_right_sidebar = _c.show_right_sidebar, show_upload_video_btn = _c.show_upload_video_btn;
    return {
        is_support_file: is_support_file,
        show_upload_video_btn: show_upload_video_btn,
        show_back_im_btn: show_back_im_btn,
        show_right_sidebar: show_right_sidebar,
        searchParams: searchParams,
        platform: platform,
        game_key: game_key,
        u: u,
        uid: uid,
        token: token,
        t: t,
        i: i,
        v: v,
        flag: flag,
        safe_area_inset_bottom: safe_area_inset_bottom,
        is_client: is_client,
        runtime: runtime
    };
};
/** 格式化参数 */
export var queryStringify = function (obj, prefix) {
    var pairs = [];
    for (var key in obj) {
        if (!Object.prototype.hasOwnProperty.call(obj, key)) {
            // eslint-disable-next-line no-continue
            continue;
        }
        var value = obj[key];
        var enkey = encodeURIComponent(key);
        var pair = void 0;
        if (typeof value === 'object') {
            pair = queryStringify(value, prefix ? "".concat(prefix, "[").concat(enkey, "]") : enkey);
        }
        else {
            pair = "".concat(prefix ? "".concat(prefix, "[").concat(enkey, "]") : enkey, "=").concat(encodeURIComponent(value));
        }
        pairs.push(pair);
    }
    return pairs.join('&');
};
/** 格式化后参数转对象 */
export var queryString = function (search) {
    var parser = /([^=?#&]+)=?([^&]*)/g;
    var result = {};
    var part;
    while ((part = parser.exec(search))) {
        var key = decodeURIComponent(part[1].replace(/\+/g, ' '));
        var value = decodeURIComponent(part[2].replace(/\+/g, ' '));
        // eslint-disable-next-line no-continue
        if (key === null || value === null || key in result)
            continue;
        result[key] = value;
    }
    return result;
};
/** 修剪对象中的空格 */
export var trimObj = function (obj) {
    var trimmedObj = {};
    Object.keys(obj).forEach(function (key) {
        if (typeof obj[key] === 'string') {
            trimmedObj[key] = obj[key].trim();
        }
        else {
            trimmedObj[key] = obj[key];
        }
    });
    return trimmedObj;
};
/**
 * 表情包相关
 */
// 选择表情
export var onSelectFace = function (item) {
    var html = "<img src=\"".concat(item.f_file_id.full_uri, "\" alt=\"").concat(item.name, "\" title=\"").concat(item.name, "\" data-uri=\"").concat(item.f_file_id.uri, "\" data-id=\"").concat(item.id, "\" data-type=\"face\">");
    return html;
};
// 表情正则转换
export var regFace = function (html) {
    var reg = /<img[^>]*src="([^"]*)"[^>]*alt="([^"]*)"[^>]*title="([^"]*)"[^>]*data-uri="([^"]*)"[^>]*data-id="([^"]*)"[^>]*data-type="([^"]*)"[^>]*>/gi;
    return html.replace(reg, '[face=$5;$4;$3]');
};
/**
 * 添加时间戳到url
 */
var appendTimestamp = function (url) {
    var stamp = "t=".concat(new Date().getTime());
    var hashIndex = url.indexOf('#');
    var hash = hashIndex >= 0 ? url.slice(hashIndex) : '';
    var withoutHash = hashIndex >= 0 ? url.slice(0, hashIndex) : url;
    var separator = withoutHash.indexOf('?') >= 0 ? '&' : '?';
    return "".concat(withoutHash).concat(separator).concat(stamp).concat(hash);
};
/** 添加script */
export var addSassScript = function (src) {
    return new Promise(function (res) {
        var script = document.createElement('script');
        script.id = 'im-sass';
        script.type = 'text/javascript';
        script.src = appendTimestamp(src);
        script.onload = res;
        script.onerror = function (e) {
            console.error('JS 加载失败:', e);
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
};
/** 添加css */
export var addSaasCss = function (href) {
    return new Promise(function (res) {
        var link = document.createElement('link');
        link.type = 'text/css';
        link.rel = 'stylesheet';
        link.href = appendTimestamp(href);
        link.onload = res;
        link.onerror = function (e) {
            console.log(e);
        };
        document.querySelectorAll('head')[0].appendChild(link);
    });
};
/** 添加通信中转页 */
export var addRelayPage = function (src) {
    var relayPageId = 'im-relay-page';
    if (!src) {
        return;
    }
    try {
        if (document.getElementById(relayPageId)) {
            return;
        }
        var iframe = document.createElement('iframe');
        iframe.id = relayPageId;
        iframe.src = src;
        iframe.title = '通信中转页';
        iframe.tabIndex = -1;
        iframe.setAttribute('aria-hidden', 'true');
        iframe.style.display = 'none';
        document.body.appendChild(iframe);
    }
    catch (error) {
        // eslint-disable-next-line no-console
        console.error('[IMBridge] 插入通信中转页失败：', error);
    }
};
/** 修改图标 */
var addFavicon = function (_a) {
    var _b = _a.title, title = _b === void 0 ? '' : _b, _c = _a.favicon, favicon = _c === void 0 ? 'favicon.ico' : _c;
    var link = document.createElement('link');
    document.title = title || '在线客服';
    link.id = 'shortcut-icon';
    link.rel = 'shortcut icon';
    link.href = favicon;
    link.onerror = function (e) {
        console.log(e);
    };
    var _link = document.getElementById('shortcut-icon');
    if (_link) {
        document
            .getElementsByTagName('head')[0]
            .removeChild(document.getElementById('shortcut-icon'));
    }
    document.getElementsByTagName('head')[0].appendChild(link);
};
/**
 * 图片相关
 */
export var getImageTypeFromBase64 = function (base64) {
    var matches = base64.match(/^data:image\/([a-z0-9+]+);base64,/i);
    return matches ? matches[1] : undefined;
};
export var base64ToBlob = function (base64) {
    var arr = base64.split(',');
    var mime = arr[0].match(/:(.*?);/)[1];
    var bstr = atob(arr[1]);
    var n = bstr.length;
    var u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
};
export var blobToBase64 = function (blob, callback) {
    var reader = new FileReader();
    reader.addEventListener('load', function () {
        callback(reader.result);
    });
    reader.readAsDataURL(blob);
};
// 图片压缩
export var Compress = function (base64, maxWidth, maxHeigth, quality, callback, failCallback) {
    var _img = new Image();
    var type = getImageTypeFromBase64(base64) || 'png';
    if (type === 'gif') {
        callback(base64, type);
        return;
    }
    if (!_.includes(['jpeg', 'png', 'gif'], type)) {
        failCallback === null || failCallback === void 0 ? void 0 : failCallback(type);
        return;
    }
    _img.src = base64;
    _img.onload = function () {
        var w = _img.width;
        var h = _img.height;
        if (w > maxWidth) {
            h *= maxWidth / w;
            w = maxWidth;
        }
        if (h > maxHeigth) {
            w *= maxHeigth / h;
            h = maxHeigth;
        }
        var _canvas = document.createElement('canvas');
        var ctx = _canvas.getContext('2d');
        _canvas.width = w;
        _canvas.height = h;
        ctx.drawImage(this, 0, 0, +w, +h);
        var base64_return = _canvas.toDataURL("image/".concat(type), quality);
        callback(base64_return, type);
    };
};
// 图片加载是否加载完成
export var imgLoad = function (message_list, callback) {
    var imgs = [];
    $(message_list)
        .children('li')
        .last()
        .find('img')
        .each(function () {
        var dfd = $.Deferred();
        $(this)
            .on('load', function () {
            dfd.resolve();
        })
            .on('error', function () {
            // 图片加载错误，加入错误处理
            dfd.resolve();
        });
        if (this.complete) {
            dfd.resolve();
        }
        imgs.push(dfd);
    });
    $.when.apply(null, imgs).done(function () {
        if (callback) {
            callback();
        }
    });
};
/**
 * 监听器
 */
export var addListener = function (e, action, callback) {
    if (e.addEventListener) {
        e.addEventListener(action, callback, false);
    }
    else {
        e.attachEvent("on".concat(action), callback);
    }
};
export var removeListener = function (e, action, callback) {
    if (e.removeEventListener) {
        e.removeEventListener(action, callback, false);
    }
    else {
        e.detachEvent("on".concat(action), callback);
    }
};
/**
 * 注入业务配置
 */
var platformInitDone = function (executeDone) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, new Promise(function (resolve) {
                var _a, _b, _c, _d;
                if (!executeDone) {
                    resolve();
                }
                (_b = (_a = window === null || window === void 0 ? void 0 : window.IMBridge) === null || _a === void 0 ? void 0 : _a.setup) === null || _b === void 0 ? void 0 : _b.call(_a, {
                    config: {
                        exitConfirmFunName: 'window.IM.SDKServer.exitWebViewConfirm'
                    },
                    listeners: {
                        onComplete: function () {
                            var _a, _b, _c, _d;
                            console.log('[IMBridge] 业务初始化完成');
                            (_b = (_a = window.IM.SDKServer) === null || _a === void 0 ? void 0 : _a.syncStage) === null || _b === void 0 ? void 0 : _b.call(_a);
                            (_d = (_c = window.IM.SDKServer) === null || _c === void 0 ? void 0 : _c.syncSession) === null || _d === void 0 ? void 0 : _d.call(_c);
                            resolve();
                        },
                        onError: function (error) {
                            var _a, _b, _c, _d;
                            console.error('[IMBridge] 业务初始化失败：', error);
                            (_b = (_a = window.IM.SDKServer) === null || _a === void 0 ? void 0 : _a.syncStage) === null || _b === void 0 ? void 0 : _b.call(_a);
                            (_d = (_c = window.IM.SDKServer) === null || _c === void 0 ? void 0 : _c.syncSession) === null || _d === void 0 ? void 0 : _d.call(_c);
                            resolve();
                        },
                        onSend: function (data) {
                            var _a, _b, _c;
                            console.log('[IMBridge] 业务发送自定义消息：', data);
                            return (_c = (_b = (_a = window.IM) === null || _a === void 0 ? void 0 : _a.CustomMessageServer) === null || _b === void 0 ? void 0 : _b.send) === null || _c === void 0 ? void 0 : _c.call(_b, data);
                        }
                    }
                });
                (_d = (_c = window === null || window === void 0 ? void 0 : window.IMBridge) === null || _c === void 0 ? void 0 : _c.init) === null || _d === void 0 ? void 0 : _d.call(_c, function (args) {
                    var _a, _b, _c, _d, _e, _f;
                    (_b = (_a = window.IM.SDKServer) === null || _a === void 0 ? void 0 : _a.exitConfirm) === null || _b === void 0 ? void 0 : _b.call(_a, 'window.IM.SDKServer.exitWebViewConfirm');
                    window.IM.args = args;
                    (_d = (_c = window.IM.SDKServer) === null || _c === void 0 ? void 0 : _c.syncStage) === null || _d === void 0 ? void 0 : _d.call(_c);
                    (_f = (_e = window.IM.SDKServer) === null || _e === void 0 ? void 0 : _e.syncSession) === null || _f === void 0 ? void 0 : _f.call(_e);
                    resolve();
                });
            })];
    });
}); };
var getRelayPageUrl = function () {
    var _a, _b;
    try {
        var relayPageUrl = (_b = (_a = window.IMBridge) === null || _a === void 0 ? void 0 : _a.getRelayPageUrl) === null || _b === void 0 ? void 0 : _b.call(_a);
        console.log('[IMBridge] 获取通信中转页地址：', relayPageUrl);
        return typeof relayPageUrl === 'string' ? relayPageUrl.trim() : '';
    }
    catch (error) {
        // eslint-disable-next-line no-console
        console.error('[IMBridge] 获取通信中转页地址失败：', error);
        return '';
    }
};
var OT_3387_SCRIPT_MAP = {
    '3387-android-app': 'https://dlstest.img4399.com/redirect/res.3387.com/ot/page/app/kefu/js/custom.js',
    '3387-android-sdk': 'http://ot.kfchat.5054399.net/chat/commonlibs/3387AndroidSDK.js',
    '3387-android-jssdk': 'http://ot.kfchat.5054399.net/chat/commonlibs/3387AndroidSDK.js',
    '3387-browser-web': 'http://ot.kfchat.5054399.net/chat/commonlibs/3387Web.js',
    '3387-browser-wap': 'http://ot.kfchat.5054399.net/chat/commonlibs/3387Web.js',
    '3387-ios-app': 'http://ot.kfchat.5054399.net/chat/commonlibs/3387IosApp.js',
    '3387-ios-sdk': 'http://ot.kfchat.5054399.net/chat/commonlibs/3387IosSDK.js'
};
export var initPlatformConfig = function (data) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, is_client, is_vip, _cssPath, _variables, _is_support_file, _show_upload_video_btn, _show_back_im_btn, _show_right_sidebar, _relayPageUrl;
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    return __generator(this, function (_q) {
        switch (_q.label) {
            case 0:
                _a = window.IM.SDKServer.getState(), is_client = _a.is_client, is_vip = _a.is_vip;
                addFavicon({
                    title: "".concat(data.config.site.title),
                    favicon: data.config.site.favicon
                });
                if (!isDev) return [3 /*break*/, 2];
                return [4 /*yield*/, addSassScript('/libs/SassBridge.js')];
            case 1:
                _q.sent();
                return [3 /*break*/, 6];
            case 2:
                if (!(window.IM.env === 'ot')) return [3 /*break*/, 4];
                return [4 /*yield*/, addSassScript(OT_3387_SCRIPT_MAP[window.IM.runtime] || data.config.js_path)];
            case 3:
                _q.sent();
                return [3 /*break*/, 6];
            case 4:
                if (!data.config.js_path) return [3 /*break*/, 6];
                return [4 /*yield*/, addSassScript(data.config.js_path)];
            case 5:
                _q.sent();
                _q.label = 6;
            case 6:
                _cssPath = is_vip ? (_b = window === null || window === void 0 ? void 0 : window.IMBridge) === null || _b === void 0 ? void 0 : _b.vipCssPath : (_c = window === null || window === void 0 ? void 0 : window.IMBridge) === null || _c === void 0 ? void 0 : _c.cssPath;
                _variables = is_vip
                    ? __assign(__assign({}, data.defaultVariables.vip), (((_d = window === null || window === void 0 ? void 0 : window.IMBridge) === null || _d === void 0 ? void 0 : _d.vipVariables) || {})) : __assign(__assign({}, data.defaultVariables.base), (((_e = window === null || window === void 0 ? void 0 : window.IMBridge) === null || _e === void 0 ? void 0 : _e.variables) || {}));
                _is_support_file = (_g = (_f = window === null || window === void 0 ? void 0 : window.IMBridge) === null || _f === void 0 ? void 0 : _f.is_support_file) !== null && _g !== void 0 ? _g : true;
                _show_upload_video_btn = (_j = (_h = window === null || window === void 0 ? void 0 : window.IMBridge) === null || _h === void 0 ? void 0 : _h.show_upload_video_btn) !== null && _j !== void 0 ? _j : true;
                _show_back_im_btn = (_l = (_k = window === null || window === void 0 ? void 0 : window.IMBridge) === null || _k === void 0 ? void 0 : _k.show_back_im_btn) !== null && _l !== void 0 ? _l : false;
                _show_right_sidebar = (_o = (_m = window === null || window === void 0 ? void 0 : window.IMBridge) === null || _m === void 0 ? void 0 : _m.show_right_sidebar) !== null && _o !== void 0 ? _o : false;
                _relayPageUrl = getRelayPageUrl();
                if (!_cssPath) return [3 /*break*/, 8];
                return [4 /*yield*/, addSaasCss(_cssPath)];
            case 7:
                _q.sent();
                _q.label = 8;
            case 8:
                if (_relayPageUrl) {
                    addRelayPage(_relayPageUrl);
                }
                if (!(is_client || ((_p = window === null || window === void 0 ? void 0 : window.IMBridge) === null || _p === void 0 ? void 0 : _p.setup))) return [3 /*break*/, 10];
                return [4 /*yield*/, platformInitDone(data.executeDone)];
            case 9:
                _q.sent();
                _q.label = 10;
            case 10:
                window.IM.SDKServer.setSuport(_is_support_file);
                window.IM.SDKServer.setShowUploadVideoBtn(_show_upload_video_btn);
                window.IM.SDKServer.setShowBackImBtn(_show_back_im_btn);
                window.IM.SDKServer.setShowRightSidebar(_show_right_sidebar);
                cssVars({
                    watch: true,
                    variables: _variables,
                    onlyLegacy: true
                });
                return [2 /*return*/, {
                        cssPath: _cssPath,
                        variables: _variables
                    }];
        }
    });
}); };
export function delay(ms) {
    if (ms === void 0) { ms = 0; }
    return new Promise(function (resolve) {
        var t = setTimeout(function () {
            clearTimeout(t);
            resolve(null);
        }, ms);
    });
}
export var copy = function (str) {
    var input = document.createElement('textarea');
    document.body.appendChild(input);
    input.innerHTML = str;
    input.select();
    document.execCommand('copy');
    document.body.removeChild(input);
};
export var base64Encode = function (str) {
    // 现代：UTF-8 -> bytes -> btoa
    if (typeof TextEncoder !== 'undefined') {
        var bytes = new TextEncoder().encode(str);
        var binary = '';
        for (var i = 0; i < bytes.length; i++) {
            binary += String.fromCharCode(bytes[i]);
        }
        return btoa(binary);
    }
    // 兼容降级：适合旧浏览器（含 IE），但用到了已废弃的 unescape
    // 实际工程里更推荐：引入 polyfill（例如 fast-text-encoding）或用成熟库处理 UTF-8。
    return btoa(unescape(encodeURIComponent(str)));
};
